import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import store from "./store";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';

// 🔥 MUI FIX
import { StyledEngineProvider } from '@mui/material/styles';

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <HelmetProvider>
    <Provider store={store}>
      <BrowserRouter>
        <StyledEngineProvider injectFirst>
          <App />
        </StyledEngineProvider>
      </BrowserRouter>
    </Provider>
  </HelmetProvider>
);

// service worker
serviceWorker.unregister();